import { Component, OnInit, ViewContainerRef, TemplateRef, ViewChild } from '@angular/core';
import { DemoService } from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import { Router } from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';


import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import { map, Observable } from 'rxjs';

import { Subscription } from 'rxjs';


import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';


import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, DataUtil } from '@syncfusion/ej2-data';
import { FilterSettingsModel } from '@syncfusion/ej2-grids';
import { IFilter } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, GroupSettingsModel } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { LegalDateTimeService } from './../../../services/legal-datetime.service';

import { SystemFile } from './../../../shared/models/file.model';
import { SystemLog } from './../../../shared/models/sysLog.model';
import { Permission } from './../../../shared/models/permission.model';
import { Brand } from './../../../shared/models/brand.model';
import { BrandType } from './../../../shared/models/brandType.model';



@Component({
  selector: 'app-client-job-view',
  templateUrl: './client-job-view.component.html',
  styleUrls: ['./client-job-view.component.css']
})
export class ClientJobViewComponent implements OnInit {

  nav: any;
  currentUserVAR: any;
  sessionUserId: any;
  sessionBrandId: any;
  job: any;
  JobStep2ID: any;
  model: any;
  job_types: any;
  job_type_locations: any;
  count2: any;
  job_type_courts: any;
  sent_job_type_location_id: any;
  job_type_document_types: any;
  sent_job_type_court_id: any;
  job_type_affidavit_types: any;
  sent_job_type_document_type_id: any;
  clients: any;
  client_contacts: any;
  sent_client_id: any;
  positionsMysql: any;
  subjects: any;
  job_type: any;
  client: any;
  clientInvoice: any;
  clientContact: any;
  bsModalRef: BsModalRef;
  modalRef: BsModalRef;
  clickHandler;
  dropdownSettings2 = {};



  afuConfig = {
    multiple: true,
    formatsAllowed: '.jpg,.png, .msg, .doc, .doc, .pdf, .mp3,',
    maxSize: '50',
    uploadAPI: {
      url: this.gfunc.php_apiURL_SSL + '/uploadFiles.php',
      method: 'POST',
      headers: {
        'Content-Type': 'text/plain;charset=UTF-8'
      },
    },
    theme: 'dragNDrop',
    hideProgressBar: false,
    hideResetBtn: true,
    hideSelectBtn: false
  };
  job_status: any;

  // map the result through the model
  create_file: SystemFile;
  //create_files: File[];
  create_sys_log: SystemLog;
  permission_model: Permission;




  accept = '*'
  files: File[] = []
  progress: number

  url = this.gfunc.php_apiURL_SSL + '/uploadFiles.php';
  hasBaseDropZoneOver: boolean = false;
  httpEmitter: Subscription;
  httpEvent: HttpEvent<{}>;
  lastFileAt: Date;

  sendableFormData: FormData; //populated via ngfFormData directive

  dragFiles: any;
  validComboDrag: any;
  lastInvalids: any;
  fileDropDisabled: any;
  maxSize: any;
  baseDropValid: any;
  job_id: any;

  tableData: any;
  client_contact: any;
  job_subject_type: any;
  job_plaintiff_type: any;
  job_type_location: any;
  job_type_court: any;
  job_type_document: any;
  job_type_affidavit: any;
  subject_notes: any;
  static returned: any; // from included components
  staffList: any;
  trace_id: any;
  assignedList: Object;
  assigned_to_list: Object;
  assignedUsers: { user_id: number; item_text: string; }[];
  user_id: any;
  sessionUsername: any;



  //sycfustion Grip
  //public data: Object[];
  public data: DataManager;
  public data_subjects: DataManager;
  public pageSettings: Object;
  public pageOptions = { pageSize: 100 };
  public filterOptions: FilterSettingsModel;
  public formatOptions: Object;
  // public filterOptions: FilterSettingsModel;
  public filter: IFilter;
  public toolbarOptions: ToolbarItems[];
  @ViewChild('grid')
  public grid: GridComponent;
  initialPage: { pageSize: number; };
  agents_assigned: any;
  job_table2: any;
  clientLocalRecord: any;
  changeObject: any;
  jobTypesLocalRecord: any;
  subjectLocalRecord: any;
  agentsAssignedLocalRecord: any;
  allocated_agents_list: string;
  agents_assigned_job: Object;

  public groupOptions: GroupSettingsModel;
  brand_report_user: Object;
  report_brand_brand: Object;
  invoice_brand_brand: Object;
  report_brand_user: any;
  subjects_urgent: Object;

  formatoptions: { type: string; format: string; };
  dateFormat: string;
  sortOptions: { columns: { field: string; direction: string; }[]; };
  today = new Date();
  file_created_response: any;
  public returned_created_file_id: any;
  file_edit_level: number;
  created_file_name: any;
  system_log_created_response: any;
  test: any;
  brand_types: BrandType;
  brands: Brand;
  user_levels: Object;
  all_router_details: string;
  current_base_route: string;

  constructor(private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
    vcr: ViewContainerRef, private router: Router, 
    public HttpClient: HttpClient,
    private fileUploader: FileUploaderService,
    private _mysqlService: MysqlService,
    private modalService: BsModalService,
    public datepipe: DatePipe,
    public gfunc: GlobalFunctionsService,
    public legalDate: LegalDateTimeService) {

    this.nav = document.querySelector('nav.navbar');
 
    this.job_id = +this.route.snapshot.paramMap.get('job_id');
    
    // login vars
// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));
this.current_base_route = this.router.url.substr(0, this.router.url.lastIndexOf('/'));



  }

  ngOnInit() {

    this.getJob(this.job_id); // used to hide the job if still pending


    /* this.trace_id = this.job_id;
    
    this.getJob(this.JobStep2ID);
    this.getJobSubjects(this.JobStep2ID);
    this.getJobTypes();
    this.getPositions();
    this.getJobStatusNames();
    // this.getJobTypeLocations(this.model.job_type_location_id); // loads default locations as nothing
    this.getJobAgentsAssigned(this.job_id);
    
    
    
    // File Permissions
    const job_id_number: number = +this.job_id;
    this.permission_model = new Permission();
      this.permission_model.brand_type_id = 2; // set default to client
      this.permission_model.job_id = job_id_number; // set default to client
      this.permission_model.created_by = this.gfunc.sessionUserId; // set default to client
      this.permission_model.created_level = this.gfunc.sessionUserLevel;
      this.permission_model.file_brand_id = this.gfunc.sessionBrandId;
    
    this.getBrandTypes();
    this.getBrands();
    this.getFormUserLevels();
    
    // this.mapJobTableLive(); // load the table
    this.getJobsTableDataSubjects(this.job_id);
    
    
    // this.groupOptions = { columns: ['file_number'] }; // sets auto grouping for the grid
    
    // drop down for assigned users
    this.dropdownSettings2 = {
    singleSelection: false,
    idField: 'user_id',
    textField: 'first_name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 15,
    allowSearchFilter: true,
    enableCheckAll: true,
    };
    
    this.getBrandUsers('94'); // for the drop down
    
    
    this.toolbarOptions = ['ExcelExport'];
    this.initialPage = { pageSize:5 };
    this.filterOptions = {
       type: 'Menu'
    };
    this.groupOptions = { columns: ['file_number'] }; // sets auto grouping for the grid
    this.formatoptions= {type:'date', format:'dd/MM/yyyy'};
    this.dateFormat = 'dd/MM/yyyy hh:mm a';
    this.filter = { params: { format: this.dateFormat } };
    this.sortOptions = { columns: [{ field: 'job_id', direction: 'Descending' } ] };
    
    
     */
  }






  getJobSubjects(job_id) {
    this._demoService.getJobSubjects(job_id).subscribe(
      data => {
        this.subjects = data;
        let res = data[0];
        this.getSubjectNotes(res.subject_id);
      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }



  getJob(job_id) {
    this._demoService.getJobID(job_id).subscribe(
      data => {
        this.job = data;
        let res = data[0];
        this.getJobType(res.job_type_id);
        this.getClientMapping(res.client_id);
        this.getClientInvoice(res.client_invoice_id);
        this.getClientContactSharmans(res.client_contact_id);
        this.getJobSubjectType(res.job_subject_type_id);
        this.getJobPlaintiffType(res.job_plaintiff_type_id);
        this.getJobTypeLocation(res.job_type_location_id);
        this.getJobTypeCourt(res.job_type_court_id);
        this.getJobTypeDocument(res.job_type_document_type_id);
        this.getJobTypeAffidavit(res.job_type_affidavit_type_id);
        this.getJobAgentAssigned(res.job_id);
        this.getReportBrand(res.brand_report_id); // get company brand
        this.getInvoiceBrand(res.brand_invoice_id); // get company invoice brand
        this.getReportBrandUser(res.brand_report_user_id); // get report brand user
      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }


  // BOF SHARMANS CALLS
  getJobTypes() {
    this._demoService.getJobTypes().subscribe(
      data => { this.job_types = data; },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }


  getJobTypeLocations(job_type_id) {
    this._demoService.getJobTypeLocations(job_type_id).subscribe(
      data => { this.job_type_locations = data; },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }


  sendJobTypeLocationsID(job_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.count2 = job_type_id;
    this.getJobTypeLocations(this.count2); // updates the selected job ID....



    console.log('sending Count:' + this.count2);
  }


  getJobTypeCourts(job_type_location_id) {
    this._demoService.getJobTypeCourts(job_type_location_id).subscribe(
      data => { this.job_type_courts = data; },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }


  sendJobTypeCourtsID(job_type_location_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_location_id = job_type_location_id;
    this.getJobTypeCourts(this.sent_job_type_location_id); // updates the selected job ID....



    console.log('sending Location:' + this.sent_job_type_location_id);
  }


  getJobTypeDocumentTypes(job_type_court_id) {
    this._demoService.getJobTypeDocumentTypes(job_type_court_id).subscribe(
      data => { this.job_type_document_types = data; },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }


  sendJobTypeDocumentTypesID(job_type_court_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_court_id = job_type_court_id;
    this.getJobTypeDocumentTypes(this.sent_job_type_court_id); // updates the selected job ID....


    console.log('sending Court Type:' + this.sent_job_type_court_id);
  }


  getJobTypeAffidavitTypes(job_type_document_type_id) {
    this._demoService.getJobTypeAffidavitTypes(job_type_document_type_id).subscribe(
      data => { this.job_type_affidavit_types = data; },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }


  sendJobTypeAffidavitTypesID(job_type_document_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_document_type_id = job_type_document_type_id;
    this.getJobTypeAffidavitTypes(this.sent_job_type_document_type_id); // updates the selected job ID....

    console.log('sending Doc Type:' + this.sent_job_type_document_type_id);
  }



  getClients() {
    this._demoService.getClients().subscribe(
      data => { this.clients = data; },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }


  getClientContactsSharmans(client_id) {
    this._demoService.getClientContactsSharmans(client_id).subscribe(
      data => { this.client_contacts = data; },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }

  getClientContactSharmans(id) {
    this._demoService.getClientContactSharmans(id).subscribe(
      data => { this.client_contact = data; },
      err => console.error(err),
      // () => console.log('done loading candidate for update')
    );
  }


  sendClientID(client_id) {
    this.sent_client_id = client_id;
    this.getClientContactsSharmans(this.sent_client_id); // updates the selected job ID....

    console.log('sending Client ID:' + this.sent_client_id);
  }

  private getPositions() {
    this._demoService.getPositions()
      .subscribe(
        res => this.positionsMysql = res,
        err => console.error(err.status)
      );
  }


  private getJobStatusNames() {
    this._demoService.getJobStatusNames()
      .subscribe(
        res => this.job_status = res,
        err => console.error(err.status)
      );
  }




  // update was here for onit but moved for onchange
  updateJobStep2(model) {
    this._demoService.updateJobStep2(model).subscribe(
      data => { // this.trace_candidate_update = data;
        // refresh the list
        // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
        this.toastr.success('Job Updated');
        // Subject to reload the manager component parent.
        // TraceCandidateManagerComponent.returned.next(false);
        this.router.navigate(['/admin/jobs/create-job-3/' + model.job_id + '']);
        return true;
      },
      error => {
        // console.error('Error saving Event!');
        this.toastr.error('Error saving Job!');
       return console.log(error);
      }
      // err => console.error(err),
      // () => console.log('done updates')
    );
  }




  // update was here for onit but moved for onchange
  updateJobSubject(model) {

    // first make a copy of subject and place in to subject_history table. // done on insert in PHP

    model.updated_by = this.sessionUserId;
    this._demoService.updateJobSubject(model).subscribe(
      data => { // this.trace_candidate_update = data;
        // refresh the list
        // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
        this.toastr.success('Subject Updated');
        // Subject to reload the manager component parent.
        // TraceCandidateManagerComponent.returned.next(false);
        this.router.navigate(['/admin/jobs/create-job-3/' + model.job_id + '']);
        return true;
      },
      error => {
        // console.error('Error saving Event!');
        this.toastr.error('Error saving Job!');
       return console.log(error);
      }
      // err => console.error(err),
      // () => console.log('done updates')


    );
  }



  getJobType(job_type_id) {
    this._demoService.getJobType(job_type_id).subscribe(
      data => {
        this.job_type = data;
      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }



  // Get the name of job type from the ID
  getClientMapping(client_id) {
    this._demoService.getClientMappingID(client_id).subscribe(
      data => {
        this.client = data;
      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }

  // Get the name of job type from the ID
  getClientInvoice(client_id) {
    this._demoService.getClientMappingID(client_id).subscribe(
      data => {
        this.clientInvoice = data;
      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }



  // Get the name of job type from the ID
  getClientContact(id) {
    this._demoService.getClientContactID(id).subscribe(
      data => {
        this.clientContact = data;
      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }


  // GET CLIENT FROM BRANDS client - brand_report_id

  getReportBrand(brand_report_id) {
    this._demoService.getBrandById(brand_report_id).subscribe(
      data => {
        this.report_brand_brand = data;
      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }


  getInvoiceBrand(brand_invoice_id) {
    this._demoService.getBrandById(brand_invoice_id).subscribe(
      data => {
        this.invoice_brand_brand = data;
      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }

  // need to get user details
  getReportBrandUser(brand_report_user_id) {
    this._demoService.getUsersById(brand_report_user_id).subscribe(
      data => { this.report_brand_user = data; },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }



  getJobSubjectType(job_subject_type_id) {
    this._demoService.getJobSubjectType(job_subject_type_id).subscribe(
      data => { this.job_subject_type = data; },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }

  getJobPlaintiffType(job_plaintiff_type_id) {
    this._demoService.getJobPlaintiffType(job_plaintiff_type_id).subscribe(
      data => { this.job_plaintiff_type = data; },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }


  getJobTypeLocation(job_type_location_id) {
    this._demoService.getJobTypeLocation(job_type_location_id).subscribe(
      data => {
        this.job_type_location = data;
        let res = data[0];
        // this.model.job_type_id = res.job_type_id;
      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }

  getJobTypeCourt(job_type_court_id) {
    this._demoService.getJobTypeCourt(job_type_court_id).subscribe(
      data => {
        this.job_type_court = data;
        // let res = data[0];
        // this.model.job_type_id = res.job_type_id;
        // this.getJobTypeLocations(res.job_type_id);


      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }



  getJobTypeDocument(job_type_document_type_id) {
    this._demoService.getJobTypeDocument(job_type_document_type_id).subscribe(
      data => {
        this.job_type_document = data;
        let res = data[0];
        // this.model.job_type_id = res.job_type_id;
      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }



  getJobTypeAffidavit(job_type_affidavit_type_id) {
    this._demoService.getJobTypeAffidavit(job_type_affidavit_type_id).subscribe(
      data => {
        this.job_type_affidavit = data;
        let res = data[0];
        // this.model.job_type_id = res.job_type_id;
      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }



  getSubjectNotes(subject_id) {
    this._demoService.getSubjectNotes(subject_id).subscribe(
      data => {
        this.subject_notes = data;
        // console.log("Done loadng USER");
        // console.log(this.users);
      },
      error => {
        //  console.error('Error Loading User!');
        //return console.log(error);
      }
    );
  }




  // MODAL
  // start of modal windows service as a template
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }








  // drop down 


  // multi select setup and action.
  onItemSelect(item: any) {
    // console.log(item);
    // this.createTraceAssignedUser(item); // insert into table
    // this.getTraceAssigned(item.trace_id); // refresh the list
  }
  onSelectAll(items: any) {
    // console.log(items);
  };


  onItemSelectAssinged(item: any, job_id, user_id) {
    // console.log(item);
    this.createJobAgentAssignedUser(item, job_id, user_id); // insert into table
    // added to auto start the strace
    //  this.startTraceDropdown(trace_id, this.sessionUserId);
    // this.getTraceAssigned(trace_id); // refresh the list
    // console.log(item, trace_id, user_id);
  };


  onSelectAllAssigned(items: any, job_id, user_id) {
    console.log(items, job_id, user_id);
    // user id not passed.
    // TODO // need to create a delete all with trace_id from assigned_user table.
    this.deleteJobAgentAssignedAll(job_id);
    // this.toastr.success('Removed All Agents from Job');
    // test a loop
    //   const num2 = items;
    // delete loop
    /* num2.forEach(item => {
     this.deleteTraceAssignedAll(item.trace_id);
     });
     */



    // TO DO // need to create an insert array of items mysql ... function. // maybe get from exec upload files fuction and sef_url etc..
    // this.createTraceAssignedUserMultiple(items, trace_id);
    const num = items;
    // insert loop
    num.forEach(item => {
      console.log(item);
      this.createJobAgentAssignedUser(item, this.job_id, item.user_id); // did not work so place a copy here
    });


    // refresh the list
    // refresh the trace
    // this.startTraceDropdown(this.job_id, this.sessionUserId);
    // this.getTraceById(this.trace_id);


  };





  onDeSelectAssigned(item: any, job_id, user_id) {
    this.deleteJobAgentAssigned(item, job_id, item.user_id);
    this.toastr.success('Removed Agent from Job');
    // refresh the trace
    // this.getTraceById(this.trace_id);
    // console.log(item);
  };

  /*
  Callback Methods
  onSelect - Return the selected item when an item is checked. Example : (onSelect)="onItemSelect($event)"
  onSelectAll - Return the all items. Example : (onSelectAll)="onSelectAll($event)".
  onDeSelect - Return the unselected item when an item is unchecked.
  Example : (onDeSelect)="onItemDeSelect($event)" onFilterChange - Return the key press. Example : (onFilterChange)="onFilterChange($event)"
  
  */
  // end drop down


  // gets the list of users assiciated for drop down.
  getBrandUsers(brand_id) {
    this._demoService.getBrandUsers(brand_id).subscribe(
      data => {
        this.staffList = data;
      },
      err => console.error(err),
      () => console.log('Candidates Loaded.')
    );
  }


  /*
  getTraceAssignedList(trace_id) {
   this._demoService.getTraceAssigned(trace_id).subscribe(
      data => { this.assigned_to_list = data;
     },
      err => console.error(err),
      () => console.log('Candidates Loaded.')
    );
  }
  */



  getJobAgentAssigned(job_id) {
    this._demoService.getJobAgentsAssigned(job_id).subscribe(
      data => {
        this.assignedList = data;
      },
      err => console.error(err),
      // () => console.log('Loaded Assigned Agents Loaded.')
    );
  }


  createJobAgentAssignedUser(item, job_id, user_id) {
    this._demoService.createJobAssigedAgent(item, job_id, user_id).subscribe(
      data => { // this.model = data;
        // refresh the list
        // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
        this.toastr.success('job Agents Updated');
        // Subject to reload the manager component parent.
        //  TraceCandidateManagerComponent.returned.next(false);
        // this.getTraceMysql(trace_id);
        return true;
      },
      error => {
        console.error('Error saving Job Agents Members!');
       return console.log(error);
      }
      // err => console.error(err),
      // () => console.log('done updates')
    );
  }

  // not required and blank in _demo from delete
  createTraceAssignedUserMultiple(items, job_id) {
    this._demoService.createTraceAssigedUserMultiple(items, job_id).subscribe(
      data => { // this.model = data;
        // refresh the list
        // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
        this.toastr.success('Trace Staff Members Updated');
        // Subject to reload the manager component parent.
        //  TraceCandidateManagerComponent.returned.next(false);
        // this.getTraceMysql(trace_id);
        return true;
      },
      error => {
        console.error('Error saving All Trace Staff Members!');
       return console.log(error);
      }
      // err => console.error(err),
      // () => console.log('done updates')
    );
  }



  deleteJobAgentAssigned(item, job_id, user_id) {
    this._demoService.deleteJobAgentAssigned(item, job_id, user_id).subscribe(
      data => {
        // refresh the list
        this.getJobAgentAssigned(job_id);
        return true;
      },
      error => {
        console.error('Error removing user from list!');
       return console.log(error);
      }
    );

  }


  deleteJobAgentAssignedAll(job_id) {
    this._demoService.deleteJobAgentAssignedAll(job_id).subscribe(
      data => {
        // refresh the list
        //  this.getTraceAssigned(trace_id);
        this.getJobAgentAssigned(job_id);
        return true;
      },
      error => {
        console.error('Error removing all users from list!');
       return console.log(error);
      }
    );

  }




  // simply auto starts the trace on assignment of staff dropdown
  startTraceDropdown(job_id, user_id) {
    user_id = this.sessionUserId; // sets the ID before its sent.


    this._demoService.startTraceDropdown(job_id, this.user_id).subscribe(
      data => { // this.model = data;
        // refresh the list
        // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
        this.toastr.warning('Trace Auto Started, Staff can now begin Subject Reporting.');
        // Subject to reload the manager component parent.
        //  TraceCandidateManagerComponent.returned.next(false);
        // this.getTraceMysql(model.trace_id);
        // this.getTraceById(trace_id);
        return true;
      },
      error => {
        // console.error('Error Starting Trace - Please Try Again!');
        this.toastr.error('Error Auto Starting Trace - Please Try Again!');
       return console.log(error);
      }
      // err => console.error(err),
      // () => console.log('done updates')
    );
  }


  toolbarClick(args: ClickEventArgs): void {
    if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
    }
  }



  refreshGrid() { // refresh the databutton
    //this.mapJobTableLive();
    this.getJobsTableDataSubjects(this.job_id, null, null, null);
    this.grid.refresh();
  };


  // New way of rendering table data
  mapJobTableLive() {

    this.getClients(); // load clients first
    this.getJobTypes();
    this.getJobSubjectsAll();
    this.getBrandUsers('94'); // for sharmans only
    this.getJobAgentsAllAssigned();




    //   this.http.get<any>(this.gfunc.apiURL + 'api/job/table/all/subjects2/' + this.job_id) // mreged data with jobs table
    this.http.get<any>(this.gfunc.apiURL + 'api/job/table/all/subjects2/' + this.job_id)

      .pipe(map(data => {
        // do your transformations
        this.job_table2 = data;

        this.job_table2.forEach(element => {
          // changed Job ID so that I had a subject ID
          element.job_id = element.subject_id;

          // local Client Name
          /*
          this.clientLocalRecord = this.clients.filter(c => c.client_id === element.client_id);
          let rs = this.clientLocalRecord;
          this.changeObject = Object.assign(this.clientLocalRecord);
          element.client_id  = this.changeObject[0].name;
          // Get Job Types
          this.jobTypesLocalRecord = this.job_types.filter(c => c.job_type_id === element.job_type_id);
          this.changeObject = Object.assign(this.jobTypesLocalRecord);
          element.job_type_id  = this.changeObject[0].job_type_name;
          */
          // Get Job Subject Name
          this.subjectLocalRecord = this.subjects.filter(c => c.subject_id === element.subject_id);
          this.changeObject = Object.assign(this.subjectLocalRecord);
          if (this.changeObject[0].first_name === null) {
            element.subject_id = '-';
          } else {
            element.subject_id = this.changeObject[0].first_name + ' ' + this.changeObject[0].surname;
          }
          this.setLegalGridDateFields(element, 'DD/MM/YYYY');
          // element.hearing_date  =  this.datepipe.transform(element.hearing_date, 'dd/MM/yyyy');
          // element.judgement_date  =  this.datepipe.transform(element.judgement_date, 'dd/MM/yyyy');
          // Agents Assigned
          /*
           this.agentsAssignedLocalRecord = this.agents_assigned.filter(c => c.job_id === element.job_id);
          this.changeObject = Object.assign(this.agentsAssignedLocalRecord);
          let recordCount = this.changeObject.length;
          console.log(recordCount);
          this.allocated_agents_list = '';
          if (recordCount < 1){
            this.allocated_agents_list = '-';
          }else{
            for (let i = 0; i < recordCount; i++) {
          this.allocated_agents_list  += this.changeObject[i].first_name + ' ' + this.changeObject[i].surname + ', ';
          } // end loop
          }
          element.allocated_to  = this.allocated_agents_list;
          */

          // Get Job Types
          this.jobTypesLocalRecord = this.job_types.filter(c => c.job_type_id === element.job_type_id);
          this.changeObject = Object.assign(this.jobTypesLocalRecord);
          element.job_type_id = this.changeObject[0].job_type_name;


        }); // end for each

        return this.job_table2;
      })
      )// end pipe
      .subscribe(results => this.job_table2 = results
      );


  }


  subjectEdit(subject_id) {
    this.router.navigate(['/admin/jobs/subject/edit/' + subject_id + '']);
  }

  subjectView(subject_id) {
    this.router.navigate(['/admin/jobs/subject/view/' + subject_id + '']);
  }



  getJobSubjectsAll() {
    this._demoService.getJobSubjectsAll().subscribe(
      data => {
        this.subjects = data;
        let res = data[0];
      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }

  getJobAgentsAllAssigned() {
    this._demoService.getJobAgentsAllAssigned().subscribe(
      data => {
        this.agents_assigned = data;
        let res = data[0];
      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }


  getJobAgentsAssigned(job_id) {
    this._demoService.getJobAgentsAssigned(job_id).subscribe(
      data => {
        this.agents_assigned_job = data;
        let res = data[0];
      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }



  jobEdit(job_id) {
    this.router.navigate(['/admin/jobs/edit/' + job_id + '']);
  }

  jobViewTabs(job_id) {
    this.router.navigate(['/admin/jobs/create-job-3/' + job_id + '']);
  }





  getJobsTableDataSubjects(job_id, brand_id, job_status_code, assigned_agent) {
    this._demoService.getJobsTableDataSubjects(job_id).subscribe(
      data => {
        this.subjects_urgent = data;
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
        this.subjects_urgent = this.applyLegalGridDateFields(DataUtil.parse.parseJson(data) as any[], 'DD/MM/YYYY');
        // console.log("Done loadng USER");
        // console.log(this.users);


      },
      error => {
        //  console.error('Error Loading User!');
        //return console.log(error);
      }
    );
  }

  private setLegalGridDateFields(element: any, displayFormat: string): void {
    ['next_date', 'final_date', 'hearing_date', 'judgement_date', 'filing_date', 'instructions_date', 'aos_date']
      .forEach((field) => {
        element[`${field}_display`] = this.legalDate.format(element[field], displayFormat);
        element[`${field}_search`] = this.legalDate.format(element[field], 'YYYY-MM-DD');
      });
  }

  private applyLegalGridDateFields(rows: any[], displayFormat: string): any[] {
    if (!Array.isArray(rows)) {
      return rows;
    }

    rows.forEach((row) => this.setLegalGridDateFields(row, displayFormat));
    return rows;
  }




  // permissions


  setFilePermissions(model) {
    // need to set file submission data to set corret file/access upon upload.
  };

  getBrandTypes() {
    this._demoService.getBrandBrandTypes().subscribe(
      data => { this.brand_types = data; },
      err => console.error(err),
      // () => console.log('done loading candidate for update')
    );
  }
  getBrands() {
    this._demoService.getBrands().subscribe(
      data2 => {
        this.brands = data2;
        // console.log(data2);
      },
      err => console.error(err),
      () => console.log('done loading User Brands')
    );
  }
  getFormUserLevels() {
    this._demoService.getFormUserLevels().subscribe(
      data2 => {
        this.user_levels = data2;
        console.log(data2);
      },
      err => console.error(err),
      //  () =>  console.log('done loading User Levels')
    );
  }


}
